import { FolderPlus, RefreshCw, Share2 } from "lucide-react";
import type { SimulatorAppSurfaceProps } from "../AppSurface.js";

const quickFolders = [
  { name: "Desktop", type: "Folder", modified: "Today 09:12" },
  { name: "Documents", type: "Folder", modified: "Today 09:08" },
  { name: "Downloads", type: "Folder", modified: "Yesterday 16:40" },
  { name: "FirstDesk-Labs", type: "Folder", modified: "Today 08:55" }
];

export function ExplorerApp({ activeMachine, app, onRunCommand }: SimulatorAppSurfaceProps) {
  return (
    <div className="fd-sim-app fd-sim-explorer">
      <div className="fd-sim-app-toolbar">
        <button
          type="button"
          onClick={() => {
            void onRunCommand({
              appId: app.id,
              commandType: "FILE_CREATE_FOLDER",
              capability: "file.folder.write",
              label: "New folder",
              payload: {
                machineId: activeMachine,
                name: "Intake",
                parentPath: "C:\\Users\\Student\\Desktop",
                path: "C:\\Users\\Student\\Desktop\\Intake"
              }
            });
          }}
        >
          <FolderPlus size={16} />
          New
        </button>
        <button
          type="button"
          onClick={() => {
            void onRunCommand({
              appId: app.id,
              commandType: "SHARE_CREATE",
              capability: "file.share.write",
              label: "Share folder",
              payload: {
                machineId: activeMachine,
                name: "Intake$",
                path: "C:\\Users\\Student\\Desktop\\Intake",
                permissions: [{ principal: "IntakeTeam", permission: "Modify" }]
              }
            });
          }}
        >
          <Share2 size={16} />
          Share
        </button>
        <button
          type="button"
          onClick={() => {
            void onRunCommand({
              appId: app.id,
              commandType: "RECORD_APP_CHECK",
              capability: app.launchCapability ?? "simulator.check",
              label: "Refresh",
              payload: { appId: app.id, title: app.title, machineId: activeMachine }
            });
          }}
        >
          <RefreshCw size={16} />
          Refresh
        </button>
      </div>
      <div className="fd-explorer-body">
        <aside className="fd-explorer-nav">
          <button className="is-active" type="button">Home</button>
          <button type="button">Desktop</button>
          <button type="button">Documents</button>
          <button type="button">This device</button>
          <button type="button">Network</button>
        </aside>
        <section className="fd-explorer-list" aria-label="Folder contents">
          <div className="fd-explorer-breadcrumb">Home &gt; {activeMachine}</div>
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Modified</th>
              </tr>
            </thead>
            <tbody>
              {quickFolders.map((folder) => (
                <tr key={folder.name}>
                  <td><span className="fd-mini-icon fd-mini-icon--folder" />{folder.name}</td>
                  <td>{folder.type}</td>
                  <td>{folder.modified}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      </div>
    </div>
  );
}
